export default __webpack_public_path__ + "static/media/route-filled.5cafba2c.svg";